import { init }  from '@amplitude/analytics-browser';
import { track } from '@amplitude/analytics-browser';
import { flush } from '@amplitude/analytics-browser';
import { identify, Identify } from '@amplitude/analytics-browser';
import { setOptOut } from '@amplitude/analytics-browser';
import { getCookieConsent } from '../helpers';

export default class amplitude {
    
    constructor(){
    }  

    //initialise amplitude api with key, user_id and custom configuration to allow events to be sent
    initialiseAmplitude(apiKey, disableCookies = true, amplitudeOptOut = true){
        init(apiKey, null, {
            defaultTracking: {
                pageViews: true,
                sessions: true,
              },
            cookieSecure: true,
            disableCookies: disableCookies,
            optOut: amplitudeOptOut,
            serverZone: 'EU',
        });
    }

    //function for handling form_submission events
    formSubmissionEvent(status){
        const eventProperties = {
            status: status,
        };
        this.fireEvent('form_submission', eventProperties);
    }

    //function for handling calculator submit events
    calculatorSubmissionEvent(status){
        const eventProperties = {
            status: status,
        };
        this.fireEvent('calculator_submission', eventProperties);
    }

    //function for handling calculator submit error events
    calculatorSubmissionError(error){
        const eventProperties = {
            error: error,
        };
        this.fireEvent('calculator_submission_error', eventProperties);
    }

    //function for handling form_consent events
    formConsentEvent(consentType, consentAction){
        const eventProperties = {
            consent_type: consentType,
            consent_action: consentAction
        };
        this.fireEvent('form_consent', eventProperties);
    }

    //function for handling range slider events
    rangeSliderEvent(newValue){
        const eventProperties = {
            newValue: newValue,
        };
        this.fireEvent('slider_interaction', eventProperties);
    }

    //function for handling range slide term events
    rangeSliderTermEvent(newTerm){
        const eventProperties = {
            newTerm: newTerm,
        };
        this.fireEvent('slider_term_interaction', eventProperties);
    }

    //function for handling range slider cta events
    rangeSliderCtaEvent(loanAmount, loanTerm){
        const eventProperties = {
            loanAmount: loanAmount,
            loanTerm: loanTerm,
        };
        this.fireEvent('range_slider_cta_click', eventProperties);
    }

    //function for handling loan summary amount events
    loanSummaryEditEvent(){
        this.fireEvent('loan_summary_edit');
    }

    //function for handling loan summary amount events
    loanSummaryEditAmountEvent(newLoanAmount){
        const eventProperties = {
            newLoanAmount: newLoanAmount,
        };
        this.fireEvent('loan_summary_amount_edit', eventProperties);
    }

    //function for handling loan summary term events
    loanSummaryEditTermEvent(newLoanTerm){
        const eventProperties = {
            newLoanTerm: newLoanTerm,
        };
        this.fireEvent('loan_summary_term_edit', eventProperties);
    }

    //function for handling fancy select events
    fancySelectEvent(formSection){
        const eventProperties = {
            formSection: formSection,
        };
        this.fireEvent('form_selection_event', eventProperties);
    }

    //function for handling drop down events
    dropDownEvent(formField){
        const eventProperties = {
            formField: formField,
        };
        this.fireEvent('form_drop_down_event', eventProperties);
    }

    //function for handling tool tip events
    tooltipEvent(formSection, tooltipText){
        const eventProperties = {
            formSection: formSection,
            tooltipText: tooltipText,
        };
        this.fireEvent('form_tooltip_interaction', eventProperties);
    }

    //function for handling input box events
    inputBoxInteractionEvent(inputBox, status) {
        const eventProperties = {
            inputBox: inputBox,
            status: status,
        };
        this.fireEvent('form_input_box_interaction', eventProperties);
    }

    //function for handling currency input box events
    currencyInputInteractionEvent(inputBox, status) {
        const eventProperties = {
            inputBox: inputBox,
            status: status,
        };
        this.fireEvent('form_currency_input_interaction', eventProperties);
    }

    //function for handling postcode interaction event events
    postcodeInputInteractionEvent(inputBox, status) {
        const eventProperties = {
            inputBox: inputBox,
            status: status,
        };
        this.fireEvent('form_postcode_interaction_event', eventProperties);
    }

    //function for handling postcode lookup events
    postcodeLookupEvent(status) {
        const eventProperties = {
            status: status,
        };
        this.fireEvent('form_postcode_lookup_event', eventProperties);
    }

    //function for handling dob interaction events
    dobInteractionEvent(dobSection) {
        const eventProperties = {
            dobSection: dobSection,
        };
        this.fireEvent('form_dob_interaction_event', eventProperties);
    }

    //function for handling dob validation events
    dobValidationEvent(status) {
        const eventProperties = {
            status: status,
        };
        this.fireEvent('form_dob_validation_event', eventProperties);
    }

    //function for handling email interaction events
    emailInputBoxInteractionEvent(status) {
        const eventProperties = {
            status: status,
        };
        this.fireEvent('form_email_interaction_event', eventProperties);
    }

    //function for handling consent interaction events
    formConsentInteractionEvent(emailConsent, smsConsent) {
        const eventProperties = {
            emailConsent: emailConsent,
            smsConsent: smsConsent
        };
        this.fireEvent('form_consent_interaction_event', eventProperties);
    }

    //function for handling elig test consent interaction events
    formConsentInteractionEventTest(emailConsent, smsConsent) {
        const eventProperties = {
            emailConsent: emailConsent,
        };
        this.fireEvent('quickform_test_consent_interaction_event', eventProperties);
    }

    //function for handling quoteboost interaction events
    quoteBoostInteractionEvent(action) {
        const eventProperties = {
            action: action,
        };
        this.fireEvent('form_quoteboost_interaction_event', eventProperties);
    }

    //function for handling sort code interaction events
    sortCodeInteractionEvent(status) {
        const eventProperties = {
            status: status,
        };
        this.fireEvent('form_sort_code_interaction_event', eventProperties);
    }

    //function for handling cta_interaction events
    //  section: page section cta was initiated
    //  buttonText: text of the button that was clicked
    //  buttonUrl: url of the page the button was clicked on
    //  targetUrl: target url for the button click event
    //  buttonColor: hex colour of the clicked button
    buttonClickEvent(section, buttonText, buttonUrl, targetUrl, buttonColor){
        const eventProperties = {
            section: section,
            button_text: buttonText,
            button_url : buttonUrl,
            target_url: targetUrl,
            button_color: buttonColor
        };
        this.fireEvent('cta_interaction', eventProperties);
    }

    //function for handling product_details events
    productDetailsEvent(cashWithdrawal){
        const eventProperties = {
            cash_withdrawal: cashWithdrawal == 'true' ? "yes" : "no",
        };
        this.fireEvent('product_details', eventProperties);
    }

    //function for handling form_application_response
    formApplicationResponse(eventProperties){
        this.fireEvent('form_application_response', eventProperties);
    }

    //function for handling quick form check events
    quickFormCheck(status){
        const eventProperties = {
            status: status,
        };
        this.fireEvent('quick_form_check', eventProperties);
    }

    //function for handling frontend errors
    logFrontendErrors(eventProperties){
        this.fireEvent('form_field_error', eventProperties);
    }

    //function for handling faq section toggle
    faqSectionToggle(faqSectionAction){
        const eventProperties = {
            faq_action: faqSectionAction,
        };
        this.fireEvent('faq_section_toggled', eventProperties);
    }

    //function for handling faq view events
    showSignposting(signpostReason){
        const eventProperties = {
            signpost: signpostReason,
            faq_action: 'shown',
        };
        this.fireEvent('faq_signpost_shown', eventProperties);
    }

    //function for handling faq_link click for vulnerable customer signposting
    faqLinkClick(signpostText = 'unknown', target = 'unknown'){
        const eventProperties = {
            signpost_text: signpostText,
            target_question: target
        };
        this.fireEvent('vulnerable_signpost_faq_click', eventProperties);        
    }

    //function for handling faq_interaction
    faqInteraction(faqText = 'unknown', action= 'unknown'){
        const eventProperties = {
            faq_question: faqText,
            action: action
        };
        this.fireEvent('faq_interaction', eventProperties);
    }

    //scores matter event progression
    scoresMatterProgress(status){
        const eventProperties = {
            status: status,
        };
        this.fireEvent('scores_matter_progression', eventProperties);
    }
    
    //function used to set user properties
    applyUserProperties(userProperties){
        if (getCookieConsent() != 'true') {
            return;
        }

        const userIdentity = new Identify();

        Object.keys(userProperties).forEach(key => {
            userIdentity.set(key, userProperties[key]);
        });
        return identify(userIdentity);
    }

    //if cookie consent is true fire event, this is required as first time customers will not have setOptOut value
    //instead the fireEvent method will only fire events if the cookie value for consent is true or it will not fire
    fireEvent(eventName, eventProperties){
        return;
        if (getCookieConsent() === 'true') {
            track(eventName, eventProperties);
        }
    }

    //function for sending stored events immediately
    flushEvents(){
        flush();
    }

}